import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BusinessBillList from 'components/Lists/BusinessBillList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container } from '../styles'

export default function CustomerBills ({ customer }) {
  const [loading, setLoading] = useState (true)
  const [bills, setBills] = useState ([])
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBills ()
  }, [customer])

  const getBills = async () => {
    try {
      const filters = '&deleted=false&order_by=created_at'
      
      const { data: bills } = await cutileiApi.get (
        `/business_bills?business_id=${businessId}&customer_id=${customer.id}&${filters}`,
        requestConfig
      )
      setBills (bills)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      {loading ? <Loading style={{marginBottom: 20}}/> : (
        <BusinessBillList
          bills={bills}
          containerStyle={{paddingInline: 10}}
          onEdit={bill => setBills (bills.map (b => b.id === bill.id ? {...bill} : b))}
          onDelete={bill => setBills (bills.filter (b => b.id !== bill.id))}
        />
      )}
    </Container>
  )
}
